module.exports = __webpack_public_path__ + "img/icon03.7d31f357.png";